import React from 'react'
import { Box, Typography } from '@material-ui/core'

type InfoProps = {
  title: string,
  value: string
}

export const Info: React.FC<InfoProps> = (props) => {
  const { title, value } = props

  return (
    <Box sx={{
      gap: { xs: 0, md: 1 },
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Typography variant='airbnbBody1' sx={{
        fontWeight: 500,
        color: 'common.white',
        opacity: '60%'
      }}>
        {title}
      </Typography>
      <Box>
        <Typography variant='airbnbH5' sx={{
          color: 'common.white'
        }}>
          {value}
        </Typography>
      </Box>
    </Box>
  )
}
